export const CountrySelectorWrapper = 'absolute h-12 py-3 pl-6 cursor-pointer'
export const CountrySelected =
  'flex items-center gap-2 text-machine2-100 font-medium'
export const CountrySelectorDropdown =
  'bg-white z-10 flex flex-col top-10 left-2 w-max border-l-4 rounded absolute text-black shadow-md'
export const CountryDropdownLabel =
  'flex items-center gap-1 cursor-pointer capitalize px-3 py-2 hover:bg-dropdownHover'
